import type { FreddyTheme } from '@coolblue-development/freddy';

export default function getPendingWrapperStyles({
  isPending,
  showLoader,
  theme
}: {
  isPending?: boolean;
  showLoader?: boolean;
  theme: FreddyTheme;
}) {
  const wrapperStyles = {
    position: showLoader ? 'relative' : 'static',
    pointerEvents: isPending ? 'none' : 'auto',
    userSelect: isPending ? 'none' : 'auto'
  } as const;

  const childrenWrapperStyles = {
    transition: `opacity ${theme.motionDuration.slow} ${theme.motionEasing.easeInOut}`,
    opacity: isPending ? 0.2 : 1
  } as const;

  const loaderStyles = {
    position: 'sticky',
    top: '50vh',
    zIndex: 1,
    // offset for the animated loader element
    '[role="status"]': {
      top: theme.spacing[600],
      [theme.breakpoint.minWidth('md')]: {
        marginLeft: '-2.9rem'
      }
    }
  } as const;

  return { wrapperStyles, childrenWrapperStyles, loaderStyles };
}
